module.exports = __webpack_public_path__ + "img/HC1032-76.ebd83245.jpg";